import { render } from "./DialogMaskList.vue?vue&type=template&id=5126ec89&scoped=true"
import script from "./DialogMaskList.vue?vue&type=script&lang=js"
export * from "./DialogMaskList.vue?vue&type=script&lang=js"

import "./DialogMaskList.vue?vue&type=style&index=0&id=5126ec89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5126ec89"]])

export default __exports__